import type { ValidateReceiveStockBulkUploadQuery } from "./__generated__/bulk-receive-operations.gql";
import { BulkReceiveSkuTypeahead } from "./bulk-receive-sku-typeahead";

export type ReceiveBulkRowValidation = NonNullable<
  ValidateReceiveStockBulkUploadQuery["validateReceiveStockBulkUpload"]
>["rows"][number];

export interface ResolvedSku {
  skuId: string;
  name: string;
}

interface Props {
  row: ReceiveBulkRowValidation;
  resolved: ResolvedSku | null;
  onResolve: (sku: ResolvedSku | null) => void;
}

export const RowSkuPicker: FC<Props> = ({ row, resolved, onResolve }) => (
  <BulkReceiveSkuTypeahead
    data-testid={`bulk-receive-sku-typeahead-${row.rowIndex}`}
    value={resolved}
    onSelect={(sku) =>
      onResolve(sku ? { skuId: sku.id, name: sku.name } : null)
    }
  />
);
